import React from 'react';
import { isMobile, notificationStore, userInfoStore } from '@pascal/pascal-core';
import {
  AdditionalResponseCode,
  betInputPlusOrMinus,
  globalTranslationKeys,
  numPadTypes,
} from '../../../../enums';
import { betSectionBoxesText } from '../../../../enums/betSectionBoxesText';

export const BetAmountSection = ({
  handleResetBetAmountSection,
  handleAddOrMinusBetAmount,
  handleChangeBetAmount,
  isDoubleSectionsOpen,
  handleChangeAmount,
  handleOpenNumPad,
  removeSection,
  activeFreeBet,
  inputDisable,
  limitParams,
  betAmount,
  limits,
  onBlur,
  index,
  t,
}) => {
  const { AllIn, Min, Max } = globalTranslationKeys;
  const { balance } = userInfoStore;
  return (
    <>
      {isDoubleSectionsOpen && (
        <div
          className={` crash-bet-close  ${!inputDisable ? 'is-show-close-btn' : ''}`}
          onClick={() => removeSection(index)}
        >
          <div className='close-btn'>
            <span className={` ${!inputDisable ? 'ui-lib-close-x' : ''}`} />
          </div>
        </div>
      )}
      <div className={`bet-sec-row row-1 ${activeFreeBet.id ? 'disabled' : ''}`}>
        <div className='bet-option-btn type-1 sm'>
          <div
            className='bet-btn-inner'
            onClick={() => {
              if (betAmount <= limits.minBet) {
                notificationStore.setNotificationType({
                  responseCode: AdditionalResponseCode.InValidMinBet,
                });
              }
              handleChangeBetAmount(index, 0.5, betSectionBoxesText.split);
            }}
          >
            <span className='mid-text'>1/2</span>
          </div>
        </div>
        <div className='bet-inpt-box big'>
          <div className='bet-inpt-box-inner'>
            <div
              className='bet-inpt-rulers '
              onClick={() => {
                if (betAmount <= limits.minBet) {
                  notificationStore.setNotificationType({
                    responseCode: AdditionalResponseCode.InValidMinBet,
                  });
                }
                handleAddOrMinusBetAmount(betInputPlusOrMinus.minus, index);
              }}
            >
              <span className=' ui-lib-minus' />
            </div>
            <input
              disabled={inputDisable}
              onChange={(e) => handleChangeAmount(e, index)}
              className='bet-opt-inp'
              type='text'
              maxLength='9'
              inputMode='none'
              value={betAmount}
              onBlur={onBlur}
              onPaste={(e) => {
                e.preventDefault();
              }}
              {...(isMobile()
                ? {
                    onClick: (e) =>
                      handleOpenNumPad(e, numPadTypes.manualBetValue, index, limitParams),
                  }
                : {})}
            />
            <div
              className='bet-inpt-rulers'
              onClick={() => {
                if (betAmount >= limits.maxBet) {
                  notificationStore.setNotificationType({
                    responseCode: AdditionalResponseCode.InValidMaxBet,
                  });
                }
                handleAddOrMinusBetAmount(betInputPlusOrMinus.plus, index);
              }}
            >
              <span className=' ui-lib-plus' />
            </div>
          </div>
        </div>
        <div className={`bet-option-btn type-1 sm ${betAmount >= limits.maxBet ? '' : ''}`}>
          <div
            className='bet-btn-inner'
            onClick={() => {
              if (betAmount >= limits.maxBet) {
                notificationStore.setNotificationType({
                  responseCode: AdditionalResponseCode.InValidMaxBet,
                });
              }
              handleChangeBetAmount(index, 2);
            }}
          >
            <span className='mid-text'>x2</span>
          </div>
        </div>
      </div>
      <div className={`bet-sec-row row-2 ${activeFreeBet.id ? 'disabled' : ''} `}>
        <div
          className={`bet-option-btn type-2  ${+betAmount === limits.minBet ? 'disabled' : ''} `}
        >
          <div
            className='bet-btn-inner'
            onClick={() => handleChangeBetAmount(index, 1, betSectionBoxesText.min)}
          >
            <span className='mid-text' title={t(Min)}>
              {t(Min)}
            </span>
          </div>
        </div>
        <div
          className={`bet-option-btn type-2 ${
            betAmount === limits.maxBet || betAmount >= limits.maxBet ? 'disabled' : ''
          }`}
        >
          <div
            className='bet-btn-inner'
            onClick={() => handleChangeBetAmount(index, 1, betSectionBoxesText.max)}
          >
            <span className='mid-text' title={t(Max)}>
              {t(Max)}
            </span>
          </div>
        </div>
        <div className={`bet-option-btn type-2 ${betAmount === balance ? 'disabled' : ''} `}>
          <div
            className='bet-btn-inner'
            onClick={() => handleChangeBetAmount(index, 1, betSectionBoxesText.allIn)}
          >
            <span className='mid-text' title={t(AllIn)}>
              {t(AllIn)}
            </span>
          </div>
        </div>
        <div className='bet-option-btn type-2 sm'>
          <div
            className='bet-btn-inner'
            onClick={() => {
              handleResetBetAmountSection(index);
            }}
          >
            {/* <span className='mid-text ui-lib-undo-clear' /> */}
            <i className='ui-lib-undo-clear icon-reset' />
          </div>
        </div>
      </div>
    </>
  );
};
